export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (config.public?.scripts?.clarity?.id) {
    onNuxtReady(async () => {
      import('@microsoft/clarity').then((clarityModule) => {
        const clarity = clarityModule.default
        clarity.init(config.public.scripts.clarity.id)
        clarity.consent(true)
      })
    })
  }
})
